import { privateGateway } from '../../../config';

export const deleteContentHubPage = async (id: number): Promise<void> => {
  const response = await privateGateway(
    process.env.REACT_APP_DOCUMENTS_API as string
  ).delete(`/pages/${id}`);

  return response.data;
};
